import { createContext, useState } from 'react'

interface UIContextProps {
	showContentToolbar: boolean
	setShowContentToolbar: (value: boolean) => void

	customContentToolbar: React.ReactNode
	setCustomContentToolbar: (value: React.ReactNode) => void
}

export const UIContext = createContext<UIContextProps>({
	showContentToolbar: true,
	setShowContentToolbar: () => {},

	customContentToolbar: null,
	setCustomContentToolbar: () => {},
})

export const UIContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [showContentToolbar, setShowContentToolbar] = useState(true)
	const [customContentToolbar, setCustomContentToolbar] = useState<React.ReactNode>()

	return (
		<UIContext.Provider
			value={{
				showContentToolbar,
				setShowContentToolbar,
				customContentToolbar,
				setCustomContentToolbar,
			}}>
			{children}
		</UIContext.Provider>
	)
}
